export default "__VITE_ASSET__D3KG9ck9__"